<template>
  <div>
    <el-button
      type="primary"
      :size="btnSize"
      @click="editClassTime"
      :disabled="btnDisable"
      icon="edit"
    >
      <slot></slot>
    </el-button>
    <Modal v-model="modalShow" width="550" footer-hide>
      <p slot="header" style="color: #f60; text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>班级信息</span>
      </p>
      <div class="flex">
        <el-form :inline="true" :model="formClassTime" label-width="84px">
          <br />
          <el-form-item label="班级时间:">
            <p>{{ formClassTime.startTime }} 至 {{ formClassTime.endTime }}</p>
          </el-form-item>
          <br />
          <el-form-item label="课程时间:" v-if="chgStart">
            <DatePicker
              v-model="formClassTime.effectStartTime"
              type="date"
              placeholder="课程时间"
              format="yyyy-MM-dd"
              placement="bottom-end"
            ></DatePicker>
          </el-form-item>
          <br />
          <el-form-item label="结课时间:" v-if="chgEnd">
            <DatePicker
              v-model="formClassTime.effectEndTime"
              type="date"
              placeholder="结课时间"
              format="yyyy-MM-dd"
              placement="bottom-end"
            ></DatePicker>
          </el-form-item>
          <br />
          <el-form-item label="入班时间:" v-if="joinTime">
            <DatePicker
              v-model="formClassTime.stujoinTime"
              type="date"
              placeholder="入班时间"
              format="yyyy-MM-dd"
              placement="bottom-end"
            ></DatePicker>
          </el-form-item>
        </el-form>
        <div class="progress">
          <p class="title">课程进度</p>
          <!-- <ul>
            <li :class="{ active: progressNum == 1 }">
              <span>第1周：</span>
              <span>{{ formClassTime.startTime }}</span>
              <span>更新</span>
            </li>
            <li
              v-for="(item, index) in newData"
              :key="index"
              :class="{ active: progressNum == index + 2 }"
            >
              <span>{{ item.currentWeek }}</span>
              <span>{{ item.currentDate }}</span>
              <span>{{ item.defaultName }}</span>
            </li>
          </ul> -->
          <ul>
            <li :class="{ active: progressNum == 1 }">
              <span>第1周：</span>
              <span>{{ formClassTime.startTime }}</span>
              <span>更新</span>
            </li>
            <li
              v-for="(item, index) in newData1"
              :key="index"
              :class="{ active: progressNum == index + 2 }"
            >
              <span>{{ item.currentWeek }}</span>
              <span>{{ item.currentDate }}</span>
              <span>{{ item.defaultName }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="jionTime" v-if="joinTime1">
        <el-form :inline="true" :model="formClassTime" label-width="84px">
          <el-form-item label="入班时间:">
            <DatePicker
              v-model="formClassTime.stujoinTime"
              type="date"
              placeholder="入班时间"
              format="yyyy-MM-dd"
              placement="bottom-end"
            ></DatePicker>
          </el-form-item>
        </el-form>
      </div>
      <Divider />

      <el-button @click="modalCancel" style="margin-left: 350px"
        >取消</el-button
      >
      <el-button type="primary" @click="modalConfirm">确定</el-button>
    </Modal>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "stuChgTime",
  components: {},
  data() {
    return {
      modalShow: false,
      formClassTime: {
        startTime: "",
        endTime: "",
        effectStartTime: "",
        effectEndTime: "",
        classCount: "",
        progressNum: "",
        kcTime: "", //课程起始时间
        stujoinTime: "",
      },
      // 时间
      countDefaul: 3,
      newData: [],
      newData1: [],
      isActive: true,
    };
  },
  props: {
    len: {
      type: Number,
      default: 1,
    },
    stuData: {
      type: Array,
      default:()=>[]
    },
    btnSize: {
      type: String,
      default: "mini",
    },
    btnDisable: {
      type: Boolean,
      default: false,
    },
    // 班级时间
    startTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    stuStartTime: {
      type: String,
      default: "",
    },
    stuEndTime: {
      type: String,
      default: "",
    },
    stujoinTime: {
      type: String,
      default: "",
    },

    currEditClassId: {
      type: Number,
      default: null,
    },
    classCount: {
      type: Number,
      default: null,
    },
    progressNum1: {
      type: String,
      default: "",
    },
    progressNum2: {
      type: Number,
      default: null,
    },
    chgStart: {
      type: Boolean,
      default: false,
    },
    chgEnd: {
      type: Boolean,
      default: false,
    },
    kcTime: {
      type: String,
      default: "",
    },
    joinTime: {
      type: Boolean,
      default: false,
    },
    joinTime1: {
      type: Boolean,
      default: false,
    },
    signupDate: {
      //报名时间
      type: String,
      default: "",
    },
  },
  created() {
    this.getData();
    this.updateTime();
    if (this.progressNum1) {
      // debugger
      this.progressNum = this.progressNum1.replace(/[^0-9]/gi, "");
    } else {
      this.progressNum = this.progressNum2;
    }
  },
  watch: {},
  methods: {
    // 获取更新时间
    updateTime() {
      // "courseId": "xxx",              //可选，课ID，不填写时，则返回班级所有课程更新时间
      let params = {
        appId: this.$API.APPID,
        classId: this.currEditClassId.toString(),
      };
      this.$axios
        .post("/edu/eduAdmin/course/list_cls_update_date", params)
        .then((res) => {
          if (res != null) {
            // debugger
            // console.log(res.data.data);
            let m = res.data;
            var newArr = m.data.slice(0);
            newArr.shift();
            // console.log(newArr)
            // debugger
            this.newData1 = [];
            newArr.forEach((item, index) => {
              this.newData1.push({
                currentWeek: `第${item.order + 1}周：`,
                currentDate: item.date,
                defaultName: "更新",
              });
            });
          }
        });
    },
    getData() {
      // debugger
      var vm = this;
      if(this.classCount) {
       var newArr = new Array(this.classCount - 1).fill("");
      this.newData = [];
      let kcTime1 = vm.getNowWeek(vm.kcTime, 1); //课程开始时间
      newArr.forEach((item, index) => {
        this.newData.push({
          currentWeek: `第${index + 2}周：`,
          currentDate: vm.getNextWeek(kcTime1, index),
          defaultName: "更新",
        });
      });
      }
      
    },
    getNextWeek(now, index) {
      var last7 = moment(now)
        .subtract("days", -7 * `${index}`)
        .format("YYYY-MM-DD");
      return last7;
    },
    getNowWeek(now, index) {
      var last7 = moment(now)
        .subtract("days", -7 * `${index}`)
        .format("YYYY-MM-DD");
      return last7;
    },
    editClassTime() {

      if (this.len > 0) {
        // let statuShow = [];
        // for (let i in this.stuData) {
        //   statuShow.push(`${this.stuData[i].status}`);
        // }
        // if (statuShow.includes("2")) {
        //   alert("该学员已经离开班级，不可以做此操作");
        //   return;
        // }
        if (this.startTime != "") {
          this.formClassTime.startTime = this.startTime;
        }
        if (this.endTime != "") {
          this.formClassTime.endTime = this.endTime;
        }
        if (this.stuStartTime != "") {
          this.formClassTime.effectStartTime = this.stuStartTime;
        }
        if (this.stuEndTime != "") {
          this.formClassTime.effectEndTime = this.stuEndTime;
        }
        if (this.stujoinTime != "") {
          // debugger
          this.formClassTime.stujoinTime = this.stujoinTime;
        }
        this.modalShow = true;
      } else {
        alert("请先选择学生");
        return;
      }
    },
    modalConfirm() {
      // debugger
      if (this.chgStart) {
        if (this.formClassTime.effectStartTime == "") {
          alert("请填写开课时间");
          return;
        }
      } else if (this.chgEnd) {
        if (this.formClassTime.effectEndTime == "") {
          alert("请填写结课时间");
          return;
        }
      } else if (
        this.formClassTime.effectStartTime != "" &&
        this.formClassTime.effectEndTime != "" &&
        this.formClassTime.effectStartTime > this.formClassTime.effectEndTime
      ) {
        alert("结课时间不允许早于开课时间");
        return;
      } else if (this.formClassTime.stujoinTime == "") {
        alert("请填写入班时间");
        return;
      }
      console.log(this.stuEndTime, "000");
      this.$emit("editClassTime", {
        startTime: this.formClassTime.startTime, //班级开课时间
        effectStartTime: this.formClassTime.effectStartTime, //学员开课时间
        effectEndTime: this.formClassTime.effectEndTime, //学员结课时间
        currEditClassId: this.currEditClassId,
        endTime: this.endTime, //班级结课时间
        stujoinTime: this.formClassTime.stujoinTime, //学员加入班级时间
      });

      this.modalShow = false;
    },
    modalCancel() {
      this.modalShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  // border: 1px solid red;
  display: flex;
  .progress {
    font-size: 14px;
    margin-left: 34px;
    width: 190px;

    .title {
      color: #ccc;
      text-align: center;
      margin-bottom: 10px;
    }
    ul {
      color: #48576a;
      height: 160px;
      overflow-y: auto;
      li {
        margin-bottom: 10px;
      }
    }
  }
}
.jionTime {
  border-top: 1px solid #e8eaec;
  margin-top: 10px;
  padding-top: 20px;
}
.active {
  color: #00a3ff !important;
}
</style>


// WEBPACK FOOTER //
// stuChgTime.vue?1be9045e